import { render, staticRenderFns } from "./TusAsientosSGA.vue?vue&type=template&id=40f7c311&scoped=true"
import script from "./TusAsientosSGA.vue?vue&type=script&lang=js"
export * from "./TusAsientosSGA.vue?vue&type=script&lang=js"
import style0 from "./TusAsientosSGA.vue?vue&type=style&index=0&id=40f7c311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7c311",
  null
  
)

export default component.exports